import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from "utils/util";
import Badge from "components/common/Badge";
import CmsPreviewShell from "./CmsPreviewShell";

const formatCountdown = (endAt) => {
  if (!endAt) return null;
  const end = new Date(endAt).getTime();
  const diff = end - Date.now();
  if (Number.isNaN(end) || diff <= 0) return "마감";
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const mins = Math.floor((diff % 3_600_000) / 60_000);
  if (days > 0) return `${days}일 ${hours}시간 남음`;
  if (hours > 0) return `${hours}시간 ${mins}분 남음`;
  return `${mins}분 남음`;
};

const EventComponent = ({ title, subtitle, layout, items = [] }) => {
  const [, setTick] = useState(0);
  const navigate = useNavigate();
  const handleClick = (link) => linkOpen(link, navigate);

  useEffect(() => {
    if (!items.some((i) => i.end_at)) return;
    const timer = setInterval(() => setTick((t) => t + 1), 60_000);
    return () => clearInterval(timer);
  }, [items]);

  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-event cms-event--${layout}`}>
        {items.map((item) => {
          const countdown = formatCountdown(item.end_at);
          const badgeColor = item.badge_color ?? "";
          return (
            <div key={item.id} className="cms-event__item"  onClick={() => handleClick(item.link)}>
              <div className="cms-event__image">
                <img src={item.img} alt={item.title} />
                {badgeColor !== '' &&  
                <span className={`cms-event__badge `}>
                  {/* {item.badge} */}
                  <Badge text={item.badge} type='solid' color='red'></Badge>
                </span>
               
                }
                {countdown && <span className="cms-event__countdown">⏱ {countdown}</span>}
              </div>
              <div className="cms-event__body">
                <h5 className="cms-event__title">{item.title}</h5>
                <p className="cms-event__desc">{item.description}</p>
                <span className="cms-event__period">{item.period}</span>
               {!isNaN(Number(item.price)) && Number(item.price) > 0 && <p className="cms-event__price">{Number(item.price).toLocaleString('ko-KR')+'원'}</p>}
              </div>
            </div>
          );
        })}
      </div>
    </CmsPreviewShell>
  );
};

export default EventComponent;
